import React from 'react';
import { Modal } from 'react-bootstrap';
import Add_Portfolio from '../forms/setup/Add_Portfolio';

function AddPortfolio(props) {
  return (
    <div>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        dialogClassName="custom-modal-width"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h5 className="text-grey">Add Portfolio</h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Add_Portfolio {...props} />
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default AddPortfolio;


